// extracted by mini-css-extract-plugin
module.exports = {"inputsWrapper":"styles_inputsWrapper__3M4X0","input":"styles_input__3Duzu"};